import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/shareModule/states/app.state';
import { selectUser } from 'src/app/shareModule/states/user-details/user-details.selector';
import { loadUser } from 'src/app/shareModule/states/user-details/user-details.action';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TemplateRefDiamondsService } from '../../layout/component-layout/profile-character/level-profile/diamonds-popup/template-ref-diamonds.service';
@Component({
  selector: 'app-advanced-settings-contribution',
  templateUrl: './advanced-settings-contribution.component.html',
  styleUrls: [
    './advanced-settings-contribution.component.scss',
    '../advanced-settings.component.scss'
  ],
})
export class AdvancedSettingsContributionComponent implements OnInit {

  constructor(
    private auth: AuthServiceService,
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
    private modalService: NgbModal,
    private templateRefDiamondsService: TemplateRefDiamondsService,
  ) { }

  ngOnInit(): void {
    this.initQuest({ page: 1 })
    this.initQuestStats()
    this._getRewardListForUser();
    this.store.pipe(select(selectUser)).subscribe((user: any) => {
      this.userInfo = user;
      this.diamonds = user.diamonds;
    });
  }

  ngAfterViewInit(): void {
    this.store.dispatch(loadUser({}));
  }

  public SUGGESTIONS_REWARD_KEY = "SUGGESTIONS_REWARD";
  public REPORTS_REWARD_KEY = "REPORTS_REWARD";
  public PRODUCTS_POST_REWARD_KEY = "PRODUCTS_POST_REWARD";
  public ASK_POST_REWARD_KEY = "ASK_POST_REWARD";
  public REVIEW_REWARD_KEY = "REVIEW_REWARD";
  public RECOMMEND_REWARD_KEY = "RECOMMEND_REWARD";
  public MOMENTS_REWARD_KEY = 'MOMENTS_REWARD'
  public userInfo: any = {};
  public diamonds: number = 0;
  public openShepherd: boolean = false;

  /**
   * 
   * @param key Suggestion > Approved Suggestion
Reports > Error/Bug Report 
Product post > product post 
Ask - no points, does not require changes
Survey per tab > listing updates
Recommendation > Approved Listing Recommendation
Moments -  no points, does not require changes
Experience > Shared an Experienc
   * @returns 
   */

  public changeRewardKeyName(key: string) {
    switch(key){
      case 'REPORTS_REWARD':{
        return 'Error/Bug Report ';
      }
      case 'GLOW_ANSER':{
        return 'Answered A Glowing Survey'

      }
      case 'REVIEW_REWARD':{
        return 'Listing Updated'

      }
      case 'SUGGESTIONS_REWARD':{
        return 'Approved Suggestion';

      }
      case 'PRODUCT_POST_REWARD':{
        return 'Product Post'
      }
      case 'XP_POST_REWARD':{
        return 'Shared An Experience'
      }
      // case 'ASK_POST_REWARD':{

      // }
      // case 'MOMENTS_REWARD':{
      //   return "Posting A Moment"

      // }
    }
    return key.toLocaleLowerCase().split('_').join(' ')
  }
  public rewardsRecieved = []
  public pointsUsed = []

  public _getRewardListForUser() {
    this.auth.getRewardListForUser().subscribe({
      next: data => {
        this.rewardsRecieved = data.body.rewards;
        this.pointsUsed = data.body.usage
        this.cdr.detectChanges()
      },
      error: console.error
    })
  }

  quest = {
    data: [],
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
  }
  initQuest({ page = 1 }) {

    this.auth.getUserQuest({ page: page }).subscribe((res: any) => {
      this.quest = res.body;
      this.cdr.detectChanges();
    })
  }

  questStats: any = {
    likes: 0,
    reports: 0,
    suggests: 0,
  }
  initQuestStats() {
    this.auth.getUserQuestStats().subscribe((res: any) => {
      this.questStats = res.body;
      this.cdr.detectChanges()

    })
  }

  public openBuyDiamonds() {
    const signinPopup = this.templateRefDiamondsService.getDiamondsPopup();
    if (signinPopup) {
      this.modalService.open(signinPopup, {
        size: 'sm',
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'diamondsPopup',
      });
    }
  }

  public maskNumber(number: any): string {
    return number ? number.toString().replace(/\d(?=\d{4})/g, "*") : "";
  }
}
